import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaGoogle, FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ImportReviewsStepTwo = () => {
  const navigate = useNavigate();
  const [isConnecting, setIsConnecting] = useState(false);

  // This would come from previous step selection
  const selectedPlatform = {
    id: 1,
    name: "Google Business",
    subtitle: "Import from Google My Business",
    icon: <FaGoogle />,
    reviews: 45,
    themeColor: "google",
  };

  const handleConnectAccount = () => {
    setIsConnecting(true);
    // Simulate connection process
    setTimeout(() => {
      navigate("/professional/import-reviews/step-3");
    }, 2000);
  };

  const handlePrevious = () => {
    navigate("/professional/import-reviews");
  };

  const handleStartImport = () => {
    navigate("/professional/import-reviews/step-3");
  };

  const CheckIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="#10B981"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M8 12.5L10.5 15L16 9.5"
        stroke="#10B981"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const securityFeatures = [
    { text: "We only read your public reviews", icon: <CheckIcon /> },
    { text: "No personal data is accessed", icon: <CheckIcon /> },
    { text: "Connections can be revoked anytime", icon: <CheckIcon /> },
    { text: "Bank-level encryption", icon: <CheckIcon /> },
  ];

  const timelineSteps = [
    { step: 1, title: "Connect Accounts", duration: "2-3 minutes" },
    { step: 2, title: "Import Reviews", duration: "1-2 minutes" },
    { step: 3, title: "Review & Publish", duration: "1 minute" },
  ];

  return (
    <div className="import-reviews pro-app-page pro-app-page--muted">
      <div className="custom_container">
        {/* Header */}
        <div className="import-header">
          <h1>Import Your Reviews</h1>
          <p className="step-indicator">
            Step 2 of 4 - Build instant credibility with your existing reviews
          </p>

          {/* Progress Bar */}
          <div className="progress-bar-container">
            <div className="progress-bar-fill" style={{ width: "50%" }}></div>
          </div>
        </div>

        <Row>
          <Col xl={8}>
            {/* Connect Your Accounts */}
            <div className="section-card">
              <div className="connect-accounts-header">
                <h3>Connect Your Accounts</h3>
                <p>
                  Securely connect your review platform accounts to import your
                  existing reviews
                </p>
              </div>

              {/* Platform Connection Card */}
              <div className="platform-connection-card">
                <div className="platform-connection-header">
                  <div className="platform-info-left">
                    <div className="platform-icon-large google-icon">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <circle
                          cx="11"
                          cy="11"
                          r="7"
                          stroke="#6c757d"
                          strokeWidth="2"
                        />
                        <path
                          d="M16 16L21 21"
                          stroke="#6c757d"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <div className="platform-details">
                      <h4>{selectedPlatform.name}</h4>
                      <p>{selectedPlatform.subtitle}</p>
                    </div>
                  </div>
                  <div className="reviews-badge">
                    <span className="reviews-count">
                      {selectedPlatform.reviews}
                    </span>
                    <span className="reviews-label">reviews to import</span>
                  </div>
                </div>

                {/* Connection Instructions */}
                <div className="connection-instructions">
                  <h5>Connection Instructions:</h5>
                  <div className="instruction-steps">
                    <div className="instruction-step">
                      <div className="step-number">1</div>
                      <p>Click "Connect Account" below</p>
                    </div>
                    <div className="instruction-step">
                      <div className="step-number">2</div>
                      <p>Sign in to your Google Business account</p>
                    </div>
                    <div className="instruction-step">
                      <div className="step-number">3</div>
                      <p>Authorize SimpleRenovate to access your reviews</p>
                    </div>
                  </div>
                </div>

                {/* Connect Button */}
                <button
                  className="connect-account-btn"
                  onClick={handleConnectAccount}
                  disabled={isConnecting}
                >
                  {isConnecting ? (
                    <>
                      <span className="spinner"></span>
                      Connecting...
                    </>
                  ) : (
                    <>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                      </svg>
                      Connect Google Business Account
                    </>
                  )}
                </button>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="step-navigation">
              <button className="nav-btn previous-btn" onClick={handlePrevious}>
                Previous
              </button>
              <button className="nav-btn start-btn" onClick={handleStartImport}>
                Start Import Process
              </button>
            </div>

            {/* Steps Indicator */}
            <div className="steps-indicator-wrapper">
              <div className="steps-indicator">
                <div className="step-item active completed">
                  <div className="step-circle">
                    <FaCheck className="check-icon" />
                  </div>
                </div>

                <div className="step-line completed"></div>

                <div className="step-item active">
                  <div className="step-circle">
                    <span className="step-number">2</span>
                  </div>
                </div>

                <div className="step-line"></div>

                <div className="step-item">
                  <div className="step-circle">
                    <span className="step-number">3</span>
                  </div>
                </div>

                <div className="step-line"></div>

                <div className="step-item">
                  <div className="step-circle">
                    <span className="step-number">4</span>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          {/* Sidebar */}
          <Col xl={4}>
            <div className="sidebar-wrapper">
              {/* Secure & Private */}
              <div className="sidebar-card security-card">
                <div className="security-header">
                  <div className="security-icon-wrapper">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 2L4 5V11C4 16.55 7.84 21.74 12 23C16.16 21.74 20 16.55 20 11V5L12 2Z"
                        stroke="#10B981"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h4>Secure & Private</h4>
                </div>

                <div className="security-features">
                  {securityFeatures.map((feature, index) => (
                    <div key={index} className="security-feature">
                      <div className="feature-icon">{feature.icon}</div>
                      <p>{feature.text}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Import Timeline */}
              <div className="sidebar-card timeline-card">
                <div className="timeline-header">
                  <h4>Import Timeline</h4>
                </div>

                <div className="timeline-steps">
                  {timelineSteps.map((item, index) => (
                    <div key={index} className="timeline-step active">
                      <div className="timeline-step-circle">
                        <span>{item.step}</span>
                      </div>
                      <div className="timeline-step-content">
                        <h5>{item.title}</h5>
                        <p>{item.duration}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ImportReviewsStepTwo;
